import { useEffect, useState } from 'react'
import { BookOpen } from 'lucide-react'
import { fetchBooks, type LifeBookNote } from '../lib/api'
import LifeModal from '../components/LifeModal'

export default function ReadingSection() {
  const [items, setItems] = useState<LifeBookNote[]>([])
  const [active, setActive] = useState<LifeBookNote | null>(null)

  useEffect(() => {
    fetchBooks().then(setItems)
  }, [])

  return (
    <section id="reading" className="scroll-mt-32 py-16">
      <header className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="text-4xl font-heading font-semibold amber-gradient-text">Reading</h2>
          <p className="text-amber-100/70 mt-1 max-w-prose">
            Books that earned a second pass. Notes, not reviews.
          </p>
        </div>
        <BookOpen className="text-amber-300/60" size={28} />
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((b, i) => (
          <button
            key={b.id}
            onClick={() => setActive(b)}
            className={`rounded-xl p-6 text-left ${i === 0 ? 'life-card-warm sm:col-span-2 lg:col-span-2' : 'life-card'}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs uppercase tracking-wider text-amber-200/70">
                {b.status}
                {b.finished ? ` · ${b.finished}` : ''}
              </span>
              {b.rating && (
                <span className="text-xs text-amber-300">{b.rating}/5</span>
              )}
            </div>
            <h3 className={`font-heading font-medium text-amber-50 ${i === 0 ? 'text-3xl' : 'text-2xl'}`}>{b.title}</h3>
            <p className={`text-amber-100/60 italic mb-2 ${i === 0 ? 'text-base' : 'text-sm'}`}>by {b.author}</p>
            {b.excerpt && (
              <p className={`text-amber-100/75 leading-relaxed ${i === 0 ? 'text-base line-clamp-4' : 'text-sm line-clamp-3'}`}>{b.excerpt}</p>
            )}
          </button>
        ))}
      </div>

      <LifeModal
        isOpen={active !== null}
        onClose={() => setActive(null)}
        title={active?.title ?? ''}
      >
        {active && (
          <div className="p-6 space-y-4">
            <div className="flex items-center justify-between text-sm text-amber-200/80">
              <span>by {active.author}</span>
              <span>
                {active.status}
                {active.finished ? ` · ${active.finished}` : ''}
                {active.rating ? ` · ${active.rating}/5` : ''}
              </span>
            </div>
            <div
              className="prose prose-invert max-w-none text-amber-100/85 prose-headings:font-heading prose-headings:text-amber-100 prose-strong:text-amber-200 prose-a:text-amber-300"
              dangerouslySetInnerHTML={{ __html: active.content_html }}
            />
          </div>
        )}
      </LifeModal>
    </section>
  )
}
